import { EProvider } from 'Common/consts';
export const getIsCommonProvider = (value) => (Object.values(EProvider).includes(value));
